import { useSnackbar } from "notistack";
import { Box, CircularProgress, Grid, Paper, TableContainer } from "@mui/material"
import { useCallback, useContext, useEffect, useRef, useState } from "react"
import { APIsContext } from "../../../Store/APIs/context"
import { AdjudicationPendingOperation, SolveAdjudicationCaseAttack, SolveAdjudicationCaseDecision } from "neurotec-megamatcherid-management-client-adjudicator"
import AdjudicationOverview from "../components/AdjudicationOverview";
import AdjudicationActionButtons from "../components/AdjudicationActionButtons";

const AdjudicationOncoming: React.FC = () => {

    const { enqueueSnackbar } = useSnackbar();
    const apiState = useContext(APIsContext).state
    const [adjudication, setAdjudication] = useState<AdjudicationPendingOperation | null>();
    const [active, setActive] = useState(true)
    
    const autoId = useRef<NodeJS.Timeout>();

    const startInterval = () => {
        autoId.current = setInterval(() => {
            fetchData()
        }, 1000)
    }

    const fetchData = useCallback(() => {
        apiState.AdjudicationApi.getOncomingAdjudicationPending().then(res => {
            setActive(true)
            setAdjudication(res.data)
            if (res.data && res.data.adjudicationPending && res.data.adjudicationPending.issues) {
                clearInterval(autoId.current)
            }
        }).catch(e => {
            enqueueSnackbar(e.message, {variant: "error"})
            clearInterval(autoId.current)
        })
    }, [apiState.AdjudicationApi, setAdjudication, enqueueSnackbar])

    useEffect(() => {
        fetchData()
        startInterval()
        return (() => {
            clearInterval(autoId.current)
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData])

    const handleSolve = (decision: SolveAdjudicationCaseDecision, attack: SolveAdjudicationCaseAttack) => {
        setActive(false)
        const uuid = adjudication?.adjudicationPending?.uuid
        apiState.AdjudicationApi.solveAdjudicationCase({
            uuid: uuid,
            decision: decision,
            attack: attack === null? SolveAdjudicationCaseAttack.AttackNone : attack
        }).then(res => {
            fetchData()
            startInterval()
        }).catch(e => {
            enqueueSnackbar(e.message, {variant: "error"})
            setActive(true)
        })
    }

    return (
        <TableContainer component={Paper} style={{marginBottom: "2rem", tableLayout: "fixed"}}>
            {/* <Button onClick={fetchData}>Refresh</Button>  */}
            {
                adjudication === null || adjudication === undefined || adjudication.operation === null || adjudication.operation === undefined?
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "25rem",
                    }}
                    >
                    <CircularProgress size={"15rem"} sx={{ marginTop: 10, marginBottom: 10 }} />
                </Box> :
                <Grid container>
                    <AdjudicationOverview
                        handleSolve={handleSolve}
                        adjudication={adjudication}
                    />
                    <AdjudicationActionButtons
                        disabled={!active}
                        handleSolve={handleSolve}
                    />
                </Grid>
            }
        </TableContainer>
    )
}

export default AdjudicationOncoming
